import { Record } from 'immutable';
import { ReadonlyRecord } from '@bimser/core';

export interface IBaseActionPropertyItem {
	key: string;
	text: string;
	data?: any;
}

export interface IActionPropertyItem extends IBaseActionPropertyItem {}

export interface ReadOnlyActionPropertyItem extends IBaseActionPropertyItem {}

export type ActionPropertyItem = ReadonlyRecord<ReadOnlyActionPropertyItem>;

export const ActionPropertyItemFactory = Record<ReadOnlyActionPropertyItem>({
	key: null,
	text: null,
	data: null
});

export const ActionPropertyItemFactoryFromJS = function (data: IActionPropertyItem) {
	return ActionPropertyItemFactory(data);
};
